import React from "react";
import styled from "styled-components";
import Container from "./Container";
import NASOnline from "./images/footer/nasonline.png";
import NAEOnline from "./images/footer/naeonline.png";
import NAMOnline from "./images/footer/namonline.png";
import ConnectFacebook from "./images/footer/connect-facebook.svg";
import ConnectEmail from "./images/footer/connect-email.svg";
import ConnectLinkedIn from "./images/footer/connect-linkedin.svg";
import ConnectRSS from "./images/footer/connect-rss.svg";
import ConnectTwitter from "./images/footer/connect-twitter.svg";
import DonateIcon from "./images/footer/donate-icon.svg";

const FooterBackground = styled.div`
  position: relative;
  background-color: var(--color-neutral--granite);
  width: 100%;
  font-weight: var(--lato--bold);
  z-index: 16;
`;

const FlexContainer = styled(Container)`
  @media print, screen and (min-width: 65rem) {
    display: -webkit-flex;
    display: flex;
  }

  @media print, screen and (max-width: 1200px) {
    max-width: 100%;
  }

  padding: 0;
  width: 100%;

  a:focus,
  a:hover {
    text-decoration: underline;
  }

  ol,
  ul {
    list-style: none;
  }
`;

const OrgLinks = styled.div`
  @media print, screen and (min-width: 65em) {
    -webkit-flex: 0 0 340px;
    flex: 0 0 340px;
  }

  -webkit-align-items: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  display: -webkit-flex;
  display: flex;
  font-size: 0.8em;
  font-size: var(--type-size--small);
  -webkit-flex-direction: column;
  flex-direction: column;
  letter-spacing: 0.1rem;
  padding-right: 1.25rem;
  padding-left: 1.25rem;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 100%;
    width: calc(100vw - 70rem);
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

const FooterLogo = styled.div`
  @media print, screen and (min-width: 65em) {
    margin-bottom: 1.5em;
  }

  display: block;
  max-width: 235px;
  margin: 2rem auto 0;
  width: 233px;

  #nas-logo {
      fill: white;
      width: 233px;
  }
`;

const OrgLink = styled.a`
  color: var(--color-neutral--white);

  @media print, screen and (min-width: 45em) {
    font-size: 0.625rem;
    font-size: var(--type-size--6);
  }

  -webkit-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: flex;
  padding-top: 0.75em;
  padding-bottom: 0.75em;
  position: relative;
  text-align: left;
  text-decoration: none;

  &:visited {
    color: var(--color-neutral--white);
  }
`;

const OrgLogo = styled.img`
  width: 1.5em;
  height: 1.5em;
  margin-right: 5px;
`;

const FooterLinks = styled.div`
  @media print, screen and (min-width: 65em) {
    -webkit-flex: 1 1 100%;
    flex: 1 1 100%;
  }

  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding: 2rem 1rem 2rem 2rem;
`;

const FooterList = styled.ul`
  @media screen and (min-width: 65em) {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-flex: 0 1 50%;
    flex: 0 1 50%;
    max-height: 200px;
    text-align: left;
  }

  padding: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2em;
  text-align: center;
`;

const FooterItem = styled.li`
  @media screen and (min-width: 65em) {
    width: 50%;
  }
`;

const FooterLink = styled.a`
  display: block;
  padding-top: 0.75em;
  padding-bottom: 0.75em;
  font-size: 1rem;
  font-weight: 700;
  font-weight: var(--lato--bold);
  text-decoration: none;
  letter-spacing: 0.05em;
  color: var(--color-neutral--white) !important;
`;

const FooterSocials = styled.div`
  @media screen and (min-width: 65em) {
    -webkit-flex: 0 1 33%;
    flex: 0 1 33%;
    margin-left: auto;
  }

  width: 100%;
`;

const FooterSocialConnect = styled.p`
  @media screen and (min-width: 65em) {
    display: block;
    text-align: left;
    margin-bottom: 1em;
  }

  text-align: center;
  margin-bottom: 1em;
  font-size: 1.15em;
  font-weight: 400;
  font-weight: var(--lato--regular);
  line-height: 1.5;
  color: var(--color-neutral--white);
`;

const FooterSocialList = styled.ul`
  @media screen and (min-width: 65em) {
    display: block;
  }

  padding: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  justify-content: center;
`;

const FooterSocialItem = styled.li`
  @media screen and (min-width: 65em) {
    margin: 0 0.5em 0.5em 0;
    float: left;
  }

  margin: 0 0.5em 0.25em;
`;

const FooterSocialLink = styled.a`
  @media screen and (min-width: 65em) {
    width: 30px;
    height: 30px;
  }

  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #fff;
  border: 1px solid var(--color-neutral--white);
  border-radius: 50%;
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.15s, -webkit-transform 0.15s;
  transition: opacity 0.15s, transform 0.15s;
  transition: opacity 0.15s, transform 0.15s, -webkit-transform 0.15s;

  &:hover {
    opacity: 1;
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

const FooterSocialImage = styled.img`
  height: 90%;
  width: 90%;
`;

const FooterLegal = styled.div`
  @media print, screen and (min-width: 65em) {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row-reverse;
    flex-direction: row-reverse;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    text-align: left;
  }

  width: 100%;
  margin-top: 1em;
  padding-top: 2em;
  border-top: 1px solid hsla(0, 0%, 100%, 0.3);
  text-align: center;
`;

const FooterLegalButton = styled.button`
  border: 1px solid #fff;
  border: 1px solid var(--color-neutral--white);
  color: #fff;
  color: var(--color-neutral--white);

  @media print, screen and (min-width: 65em) {
    -webkit-order: 2;
    order: 2;
    margin-bottom: 0;
  }

  margin-bottom: 2rem;
  background-color: transparent;
  padding: 1.2em 1.5em;
  padding-right: 2.5rem;

  display: inline-block;
  font-size: 0.75rem;
  font-weight: 900;
  font-weight: var(--lato--black);
  letter-spacing: 2px;

  position: relative;
  text-align: left;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 0.15s, border-color 0.15s;

  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif;
  font-family: var(--type-font--lato);

  border-radius: 0;

  &:active,
  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;

const FooterLegalSpan = styled.span`
  display: block;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 4.25em;
`;

const FooterLegalIcon = styled.img`
  height: 2.5em;
  position: absolute;
  top: 50%;
  left: 60%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 2.5em;
`;

const FooterLegalList = styled.ul`
  padding: 0;
`;

const FooterLegalItem = styled.li`
  @media print, screen and (min-width: 65em) {
    display: inline-block;

    & + li:before {
      content: "|";
      display: inline-block;
      margin-right: 0.5em;
      margin-left: 0.5em;
      font-weight: 300;
      font-weight: var(--lato--light);
      color: var(--color-neutral--white);
    }
  }
`;

const FooterLegalLink = styled.a`
  @media print, screen and (min-width: 65em) {
    display: inline-block;
    margin-bottom: 0;
  }

  display: block;
  margin-bottom: 0.5em;
  font-size: 0.95em;
  font-weight: 700;
  font-weight: var(--lato--bold);
  text-decoration: none;
  color: var(--color-neutral--white);

  &:visited {
    color: var(--color-neutral--white);
  }
`;

const FooterLegalCopyright = styled.p`
  @media print, screen and (min-width: 65em) {
    margin-top: 0.5em;
  }

  margin-top: 1em;
  font-size: 0.9em;
  opacity: 0.9;
  font-weight: 300;
  font-weight: var(--lato--light);
  line-height: 1.5;
`;

const FooterLegalCopyrightLink = styled.a`
  @media print, screen and (min-width: 65em) {
    display: inline-block;
    margin-bottom: 0;
  }

  display: block;
  margin-bottom: 0.5em;
  font-size: 0.8em;
  font-weight: var(--lato--bold);
  text-decoration: none;
  color: var(--color-neutral--white);

  &:visited {
    color: var(--color-neutral--white);
  }
`;

function Footer() {
  return (
    <FooterBackground>
      <FlexContainer>
        <OrgLinks>
          <FooterLogo>
            <svg xmlns="http://www.w3.org/2000/svg" id="nas-logo" width="250" viewBox="0 0 360 66.64" alt="National Academies logo">
                <defs></defs>
                <path d="m4.26 8.63 19.56 20.49V1.72h-3.47v18.93L.8.16v27.32h3.46V8.63zM32.55 27.48h3.83l8.15-19.2 7.93 18.99.09.21h3.82L44.62 0 32.55 27.48zM175.05 27.48h3.83l8.16-19.2 7.93 18.99.08.21h3.83L187.12 0l-12.07 27.48zM68.23 27.48h3.47V5.03h7.72V1.72H60.51v3.31h7.72v22.45zM90.08 1.72h3.46v25.76h-3.46z" class="cls-1"></path>
                <path d="M157.14 38.67A13.39 13.39 0 1 0 143.75 52a13.21 13.21 0 0 0 13.39-13.33Zm-3.54 0a9.85 9.85 0 1 1-9.85-10 9.93 9.93 0 0 1 9.85 10Z" class="cls-1" transform="translate(-24.97 -24.05)"></path>
                <path d="m146.56 8.63 19.56 20.49V1.72h-3.47v18.93L143.1.16v27.32h3.46V8.63zM210.95 1.72h-3.46v25.76h13.8v-3.31h-10.34V1.72z" class="cls-1"></path>
                <path d="M67.41 63A13.13 13.13 0 0 0 54 76.37a13 13 0 0 0 13.26 13.24A13.48 13.48 0 0 0 75 87.1l.14-.1v-4.46l-.58.58a10.91 10.91 0 0 1-2.81 2 10 10 0 0 1-4.51 1.13c-6.74 0-9.77-5.78-9.77-9.89a9.82 9.82 0 0 1 9.74-10.11 10.44 10.44 0 0 1 4.18.94 12 12 0 0 1 3.17 2.27l.58.58v-4.41l-.13-.1a12.1 12.1 0 0 0-7.6-2.53ZM130 66.4a14 14 0 0 0-9.47-3h-5.45v25.75h5.42c4.25 0 6.88-.83 9.39-3a12.32 12.32 0 0 0 4.52-9.89A12.54 12.54 0 0 0 130 66.4Zm-2.39 17.26a10.37 10.37 0 0 1-7 2.18h-2.11V66.7h2.11c6.21 0 10.22 3.77 10.22 9.59a9.23 9.23 0 0 1-3.25 7.37Z" class="cls-1" transform="translate(-24.97 -24.05)"></path>
                <path d="M119.94 65.11h15.33V61.8h-11.86v-9.07h10.38v-3.31h-10.38v-6.76h11.86v-3.32h-15.33v25.77zM201.26 65.11h15.33V61.8h-11.86v-9.07h10.37v-3.31h-10.37v-6.76h11.86v-3.32h-15.33v25.77zM158.66 58.65l-9.79-21.53-4.42 27.99h3.56l2.36-16.59 8.25 18.12 8.35-18.12 2.25 16.59h3.56l-4.14-28.03-9.98 21.57zM184.29 39.34h3.46V65.1h-3.46z" class="cls-1"></path>
                <path d="M263.7 76.76a12.7 12.7 0 0 0-4-2.44l-2.42-1a8 8 0 0 1-2.53-1.51 2.32 2.32 0 0 1-.83-1.94c0-2.11 1.56-3.53 3.87-3.53a4.18 4.18 0 0 1 2.61.79 5.51 5.51 0 0 1 1.37 1.77l.17.34 2.8-1.85-.14-.27a7.79 7.79 0 0 0-2.56-2.91 7.16 7.16 0 0 0-4.18-1.21c-4.34 0-7.37 2.8-7.37 6.8a5.53 5.53 0 0 0 1.83 4.35 10.74 10.74 0 0 0 3.24 2l2.44 1.17a10.81 10.81 0 0 1 2.94 1.68 3.39 3.39 0 0 1 1.13 2.68A4.8 4.8 0 0 1 254 85a5.6 5.6 0 0 1-1.42-3l-.05-.39-3.4.94.07.32a9.51 9.51 0 0 0 2.43 4.61 7.73 7.73 0 0 0 5.69 2.13 7.9 7.9 0 0 0 8.28-8 6.38 6.38 0 0 0-1.9-4.85Z" class="cls-1" transform="translate(-24.97 -24.05)"></path>
                <path d="M0 65.11h3.83l8.16-19.21 7.92 19 .09.21h3.83L12.07 37.63 0 65.11zM57.37 65.11h3.83l8.15-19.21 7.93 19 .08.21h3.83L69.44 37.63 57.37 65.11z" class="cls-1"></path>
                <path d="M292 26.45a3.91 3.91 0 0 0-1.07-.14 2.94 2.94 0 0 0-1.74.52 1.71 1.71 0 0 0-.72 1.47 2.36 2.36 0 0 0 .63 1.7 9.45 9.45 0 0 0 1.9 1.38 15.52 15.52 0 0 1 1.45 1 4.28 4.28 0 0 1 .94 1.12 2.87 2.87 0 0 1 .38 1.51 3.57 3.57 0 0 1-.57 2 3.79 3.79 0 0 1-1.6 1.34 5.79 5.79 0 0 1-2.39.47 9.63 9.63 0 0 1-2.22-.25 4.15 4.15 0 0 1-1.41-.52l.39-2.49H287l.11 1.84a2.93 2.93 0 0 0 .92.39 5 5 0 0 0 1.16.14 3.39 3.39 0 0 0 2-.6 1.94 1.94 0 0 0 .83-1.68 2.25 2.25 0 0 0-.56-1.54 7.66 7.66 0 0 0-1.7-1.32c-.6-.39-1.1-.75-1.51-1.07a4.43 4.43 0 0 1-1-1.2 2.94 2.94 0 0 1-.43-1.59 3.08 3.08 0 0 1 .57-1.85 3.58 3.58 0 0 1 1.55-1.23 5.17 5.17 0 0 1 2.13-.43 7.84 7.84 0 0 1 2 .21 4 4 0 0 1 1.25.51l-.4 2.31h-.95l-.14-1.68a2.39 2.39 0 0 0-.83-.32ZM300.27 29.79a2.2 2.2 0 0 0-1.53.62 4.15 4.15 0 0 0-1.06 1.74 8 8 0 0 0-.38 2.55 4.11 4.11 0 0 0 .5 2.24 1.6 1.6 0 0 0 1.42.74 2.71 2.71 0 0 0 1.25-.27 5.56 5.56 0 0 0 1.15-.81l.35.64a4.42 4.42 0 0 1-1.31 1.08 3.78 3.78 0 0 1-2 .5 2.76 2.76 0 0 1-2.31-1 4.51 4.51 0 0 1-.83-2.9 7.35 7.35 0 0 1 .6-2.87 6 6 0 0 1 1.77-2.38 4.27 4.27 0 0 1 2.77-.95 5.7 5.7 0 0 1 1.06.11 3.31 3.31 0 0 1 .92.3l-.48 1.7-.29-.11a2.91 2.91 0 0 0-1.6-.93ZM306.13 37.31a.54.54 0 0 0 .08.33.22.22 0 0 0 .2.11.74.74 0 0 0 .39-.12 2.88 2.88 0 0 0 .5-.4l.23.42a3.34 3.34 0 0 1-.78.77 2 2 0 0 1-1.23.4 1.3 1.3 0 0 1-.89-.27.9.9 0 0 1-.26-.81c0-.3.18-1.43.46-3.41q.24-1.59.6-4.23l-1.09-.4.11-.6 2.49-.4.38.19-1.17 8.25Zm-.08-10.8a1 1 0 0 1-.27-.69 1.24 1.24 0 0 1 .34-.89 1.07 1.07 0 0 1 .82-.37.94.94 0 0 1 .7.27.93.93 0 0 1 .26.66 1.35 1.35 0 0 1-.33.92 1.14 1.14 0 0 1-.88.38.9.9 0 0 1-.64-.28ZM315.15 38.24a4.26 4.26 0 0 1-2.23.6 3.45 3.45 0 0 1-2-.53 3.23 3.23 0 0 1-1.15-1.41 4.83 4.83 0 0 1-.36-1.87 7.38 7.38 0 0 1 .67-3.14 5.91 5.91 0 0 1 1.92-2.33 4.33 4.33 0 0 1 2.62-.88 2.64 2.64 0 0 1 1.88.6 2.06 2.06 0 0 1 .63 1.56 2.66 2.66 0 0 1-1 2.11 6.62 6.62 0 0 1-2.37 1.28 9.48 9.48 0 0 1-2.46.45 3.85 3.85 0 0 0 .42 2.13 1.68 1.68 0 0 0 1.6.91 3.61 3.61 0 0 0 1.54-.36 4.41 4.41 0 0 0 1.39-1l.38.65a4.39 4.39 0 0 1-1.48 1.23Zm-2.41-8a4.82 4.82 0 0 0-1 1.65 7.41 7.41 0 0 0-.44 1.94 5.85 5.85 0 0 0 1.86-.39 4.34 4.34 0 0 0 1.6-1 2 2 0 0 0 .65-1.46 1.5 1.5 0 0 0-.33-1.05 1.14 1.14 0 0 0-.88-.35 2 2 0 0 0-1.46.67ZM323.42 29.32a3.62 3.62 0 0 1 2-.64 1.89 1.89 0 0 1 1.51.6 2.93 2.93 0 0 1 .53 1.95 16.77 16.77 0 0 1-.39 2.68l-.07.4-.14.85a12.6 12.6 0 0 0-.28 2.12c0 .32.08.47.23.47a1.35 1.35 0 0 0 .82-.44l.21.46a1.7 1.7 0 0 1-.36.4 2.81 2.81 0 0 1-.7.45 1.92 1.92 0 0 1-.9.2c-.74 0-1.11-.35-1.11-1.07a14.6 14.6 0 0 1 .32-2.14l.16-.84.07-.42c.11-.63.21-1.18.28-1.66a9 9 0 0 0 .1-1.32 2 2 0 0 0-.23-1.12 1 1 0 0 0-.84-.3 2.63 2.63 0 0 0-1.57.69 6.6 6.6 0 0 0-1.48 1.67l-.86 6.34H319l1.13-8.49-.86-.42.14-.67 2.14-.39.37.2-.23 2.1a6.56 6.56 0 0 1 1.73-1.66ZM334.3 29.79a2.22 2.22 0 0 0-1.53.62 4.14 4.14 0 0 0-1 1.74 7.68 7.68 0 0 0-.38 2.55 4.11 4.11 0 0 0 .49 2.24 1.61 1.61 0 0 0 1.42.74 2.78 2.78 0 0 0 1.26-.27 5.52 5.52 0 0 0 1.14-.81l.36.64a4.56 4.56 0 0 1-1.31 1.08 3.85 3.85 0 0 1-2 .5 2.79 2.79 0 0 1-2.31-1 4.57 4.57 0 0 1-.83-2.9 7.19 7.19 0 0 1 .61-2.87 5.94 5.94 0 0 1 1.77-2.38 4.24 4.24 0 0 1 2.76-.95 5.7 5.7 0 0 1 1.06.11 3.2 3.2 0 0 1 .92.3l-.47 1.7-.3-.11a2.91 2.91 0 0 0-1.66-.93ZM343.32 38.24a4.26 4.26 0 0 1-2.23.6 3.42 3.42 0 0 1-1.95-.53A3.17 3.17 0 0 1 338 36.9a4.66 4.66 0 0 1-.37-1.87 7.53 7.53 0 0 1 .67-3.14 6 6 0 0 1 1.86-2.33 4.36 4.36 0 0 1 2.63-.88 2.65 2.65 0 0 1 1.88.6 2.06 2.06 0 0 1 .63 1.56 2.69 2.69 0 0 1-1 2.11 6.66 6.66 0 0 1-2.38 1.28 9.33 9.33 0 0 1-2.46.45 4 4 0 0 0 .42 2.13 1.68 1.68 0 0 0 1.6.91 3.65 3.65 0 0 0 1.55-.36 4.37 4.37 0 0 0 1.38-1l.39.65a4.43 4.43 0 0 1-1.48 1.23Zm-2.4-8a4.67 4.67 0 0 0-1 1.65 7 7 0 0 0-.44 1.94 5.79 5.79 0 0 0 1.85-.39 4.25 4.25 0 0 0 1.6-1 2 2 0 0 0 .65-1.46 1.5 1.5 0 0 0-.32-1.05 1.17 1.17 0 0 0-.89-.35 1.93 1.93 0 0 0-1.45.67ZM351.91 29.91a3.08 3.08 0 0 0-1.24-.24 2.15 2.15 0 0 0-1.3.35 1.18 1.18 0 0 0-.49 1 1.54 1.54 0 0 0 .4 1.06 6.17 6.17 0 0 0 1.13 1c.42.33.76.61 1 .85a3.35 3.35 0 0 1 .67.87 2.38 2.38 0 0 1 .3 1.2 2.4 2.4 0 0 1-1 2.07 4.21 4.21 0 0 1-2.53.73 7.55 7.55 0 0 1-1.57-.17 2.73 2.73 0 0 1-1-.39l.29-1.21a3.77 3.77 0 0 0 1 .5 3.94 3.94 0 0 0 1.36.24 2.47 2.47 0 0 0 1.31-.33 1.14 1.14 0 0 0 .55-1.06 1.58 1.58 0 0 0-.43-1.09 8 8 0 0 0-1.26-1 3.53 3.53 0 0 1-1.81-2.86 2.43 2.43 0 0 1 .46-1.45 2.92 2.92 0 0 1 1.25-1 4.48 4.48 0 0 1 1.75-.34 7.2 7.2 0 0 1 1.29.12 4.56 4.56 0 0 1 .92.22l-.3 1.33a1.83 1.83 0 0 0-.75-.4ZM287 50.81h8.32l-.12 2.79h-1l-.28-1.84-4-.14-.67 5 4.07-.14-.12 1.32-4-.14-.81 5.34 4.95-.21 1-2.12 1 .19-.71 3h-9.33l.07-.68 1.32-.21 1.4-11.19-1.19-.2ZM301.65 54.52a3.52 3.52 0 0 1 2-.64 1.89 1.89 0 0 1 1.51.6 2.89 2.89 0 0 1 .53 1.94 16.85 16.85 0 0 1-.39 2.69l-.07.4-.14.84a12.68 12.68 0 0 0-.28 2.13c0 .31.07.47.23.47a1.41 1.41 0 0 0 .82-.44l.14.49a1.76 1.76 0 0 1-.37.4 3.17 3.17 0 0 1-.69.45 2 2 0 0 1-.9.2A1 1 0 0 1 303 63a14.6 14.6 0 0 1 .32-2.14l.16-.84.07-.42c.11-.64.21-1.19.28-1.66a9.18 9.18 0 0 0 .1-1.33 2 2 0 0 0-.23-1.11 1 1 0 0 0-.84-.31 2.59 2.59 0 0 0-1.57.7 6.6 6.6 0 0 0-1.48 1.67l-.86 6.33h-1.67l1.13-8.49-.86-.42.14-.66 2.14-.39.37.19-.23 2.11a6.56 6.56 0 0 1 1.68-1.71ZM313.74 66.64a4.23 4.23 0 0 1-1.77 1.2 5.86 5.86 0 0 1-2 .37 7.37 7.37 0 0 1-1.13-.09 4.89 4.89 0 0 1-.87-.22l.37-1.42a6.44 6.44 0 0 0 1 .39 4.29 4.29 0 0 0 1.22.18 2.62 2.62 0 0 0 1.66-.43 2.58 2.58 0 0 0 .71-1.62l.33-2.33a4.25 4.25 0 0 1-1.18 1 3 3 0 0 1-1.52.39 2.52 2.52 0 0 1-2.17-1 4.5 4.5 0 0 1-.72-2.68 7.33 7.33 0 0 1 .66-3 6.45 6.45 0 0 1 1.95-2.49 4.73 4.73 0 0 1 3-1 5.1 5.1 0 0 1 1 .11 5.19 5.19 0 0 1 .91.28l1.09-.39-1.58 10.63a3.73 3.73 0 0 1-.96 2.12ZM313 54.81a2.66 2.66 0 0 0-2 .85 5.43 5.43 0 0 0-1.22 2.11 7.91 7.91 0 0 0-.4 2.46 3.81 3.81 0 0 0 .42 2 1.31 1.31 0 0 0 1.17.71 2.42 2.42 0 0 0 1.37-.44 3.83 3.83 0 0 0 1-1l.93-6.28a2.13 2.13 0 0 0-1.27-.41ZM320.16 62.51a.56.56 0 0 0 .08.32.24.24 0 0 0 .2.12.8.8 0 0 0 .4-.12 4.16 4.16 0 0 0 .5-.41l.23.42a3.57 3.57 0 0 1-.78.78 2 2 0 0 1-1.24.4 1.32 1.32 0 0 1-.89-.27.92.92 0 0 1-.25-.82c0-.29.18-1.43.46-3.4.16-1.07.36-2.48.59-4.23l-1.09-.4.11-.6 2.49-.4.39.19-1.18 8.25Zm-.08-10.81a.93.93 0 0 1-.27-.68 1.25 1.25 0 0 1 .35-.89 1 1 0 0 1 .81-.37.93.93 0 0 1 .7.27.9.9 0 0 1 .27.66 1.36 1.36 0 0 1-.34.92 1.11 1.11 0 0 1-.88.37.87.87 0 0 1-.64-.28ZM328.56 54.52a3.54 3.54 0 0 1 2-.64 1.89 1.89 0 0 1 1.51.6 2.89 2.89 0 0 1 .53 1.94 16.85 16.85 0 0 1-.39 2.69l-.07.4-.14.84a12.68 12.68 0 0 0-.28 2.13c0 .31.08.47.23.47a1.41 1.41 0 0 0 .82-.44l.23.49a1.76 1.76 0 0 1-.37.4 3.17 3.17 0 0 1-.69.45 2 2 0 0 1-.9.2 1 1 0 0 1-1.16-1.05 14.6 14.6 0 0 1 .32-2.14l.16-.84.07-.42c.11-.64.21-1.19.28-1.66a9.18 9.18 0 0 0 .1-1.33 2 2 0 0 0-.23-1.11 1 1 0 0 0-.84-.31 2.59 2.59 0 0 0-1.57.7 6.6 6.6 0 0 0-1.48 1.67l-.86 6.33h-1.67l1.13-8.49-.86-.42.14-.66 2.14-.39.37.19-.23 2.11a6.56 6.56 0 0 1 1.71-1.71ZM340.41 63.44a4.26 4.26 0 0 1-2.23.6 3.35 3.35 0 0 1-1.95-.54 3 3 0 0 1-1.15-1.4 4.66 4.66 0 0 1-.37-1.87 7.38 7.38 0 0 1 .67-3.14 5.91 5.91 0 0 1 1.86-2.33 4.29 4.29 0 0 1 2.62-.88 2.62 2.62 0 0 1 1.88.6 2 2 0 0 1 .63 1.56 2.63 2.63 0 0 1-1 2.1 6.47 6.47 0 0 1-2.37 1.28 9.38 9.38 0 0 1-2.46.46A4 4 0 0 0 337 62a1.69 1.69 0 0 0 1.6.9 3.61 3.61 0 0 0 1.54-.36 4.27 4.27 0 0 0 1.39-1l.39.65a4.68 4.68 0 0 1-1.51 1.25Zm-2.4-8a4.53 4.53 0 0 0-1 1.65 6.69 6.69 0 0 0-.44 1.94 6.13 6.13 0 0 0 1.85-.39 4.25 4.25 0 0 0 1.6-1 2 2 0 0 0 .65-1.46 1.55 1.55 0 0 0-.32-1.05 1.14 1.14 0 0 0-.89-.36 2 2 0 0 0-1.46.68ZM349.39 63.44a4.26 4.26 0 0 1-2.23.6 3.35 3.35 0 0 1-2-.54 3.09 3.09 0 0 1-1.15-1.4 4.66 4.66 0 0 1-.37-1.87 7.38 7.38 0 0 1 .68-3.14 5.91 5.91 0 0 1 1.86-2.33 4.25 4.25 0 0 1 2.62-.88 2.65 2.65 0 0 1 1.88.6 2 2 0 0 1 .63 1.56 2.66 2.66 0 0 1-1 2.1 6.51 6.51 0 0 1-2.31 1.28 9.38 9.38 0 0 1-2.46.46 3.94 3.94 0 0 0 .43 2.13 1.66 1.66 0 0 0 1.59.9 3.65 3.65 0 0 0 1.55-.36 4.34 4.34 0 0 0 1.38-1l.39.65a4.68 4.68 0 0 1-1.49 1.24Zm-2.4-8a4.67 4.67 0 0 0-1 1.65 7 7 0 0 0-.44 1.94 6.07 6.07 0 0 0 1.85-.39 4.38 4.38 0 0 0 1.61-1 2 2 0 0 0 .65-1.46 1.5 1.5 0 0 0-.33-1.05 1.14 1.14 0 0 0-.89-.36 2 2 0 0 0-1.44.68ZM356.34 55.24a4.21 4.21 0 0 1 1.13-1 2.81 2.81 0 0 1 1.4-.38.93.93 0 0 1 .56.12l-.37 1.86a1.64 1.64 0 0 0-.86-.18 2.68 2.68 0 0 0-1.48.5 3.31 3.31 0 0 0-1.14 1.4l-.8 6.24h-1.69l1.11-8.45-.88-.44.12-.65 2.07-.4.35.21-.12 1.56-.08.7a3.9 3.9 0 0 1 .68-1.09ZM362.32 62.51a.56.56 0 0 0 .08.32.23.23 0 0 0 .2.12.8.8 0 0 0 .4-.12 4.16 4.16 0 0 0 .5-.41l.22.42a3.18 3.18 0 0 1-.78.78 2 2 0 0 1-1.23.4 1.3 1.3 0 0 1-.89-.27.92.92 0 0 1-.25-.82c0-.29.17-1.43.45-3.4.17-1.07.36-2.48.6-4.23l-1.09-.4.11-.6 2.49-.4.38.19-1.17 8.25Zm-.08-10.81a.93.93 0 0 1-.24-.7 1.24 1.24 0 0 1 .34-.89 1.07 1.07 0 0 1 .82-.37.94.94 0 0 1 .7.27.93.93 0 0 1 .26.66 1.35 1.35 0 0 1-.33.92 1.12 1.12 0 0 1-.88.37.86.86 0 0 1-.67-.26ZM370.36 54.52a3.55 3.55 0 0 1 2-.64 1.91 1.91 0 0 1 1.51.6 2.89 2.89 0 0 1 .52 1.94 17.7 17.7 0 0 1-.38 2.69l-.07.4-.14.84a12.68 12.68 0 0 0-.28 2.13c0 .31.07.47.22.47a1.4 1.4 0 0 0 .83-.44l.21.46a1.76 1.76 0 0 1-.37.4 3.74 3.74 0 0 1-.69.45 2.13 2.13 0 0 1-.91.2 1 1 0 0 1-1.1-1.07 14.1 14.1 0 0 1 .31-2.14l.16-.84.07-.42c.12-.64.21-1.19.28-1.66a9.27 9.27 0 0 0 .11-1.33 1.88 1.88 0 0 0-.24-1.11 1 1 0 0 0-.83-.31 2.59 2.59 0 0 0-1.57.7 6.6 6.6 0 0 0-1.48 1.67l-.86 6.33H366l1.12-8.49-.86-.42.14-.66 2.14-.39.37.19-.23 2.11a6.72 6.72 0 0 1 1.68-1.66ZM382.46 66.64a4.23 4.23 0 0 1-1.77 1.2 5.87 5.87 0 0 1-2 .37 7.34 7.34 0 0 1-1.12-.09 4.82 4.82 0 0 1-.88-.22l.37-1.42a6.58 6.58 0 0 0 1 .39 4.24 4.24 0 0 0 1.22.18 2.57 2.57 0 0 0 1.65-.43 2.53 2.53 0 0 0 .72-1.62l.33-2.33a4.25 4.25 0 0 1-1.18 1 3.07 3.07 0 0 1-1.52.39 2.52 2.52 0 0 1-2.17-1 4.5 4.5 0 0 1-.73-2.68 7.35 7.35 0 0 1 .67-3 6.27 6.27 0 0 1 1.95-2.51 4.71 4.71 0 0 1 3-1 5.1 5.1 0 0 1 1 .11 5.47 5.47 0 0 1 .91.28l1.09-.39-1.58 10.63a3.86 3.86 0 0 1-.96 2.14Zm-.7-11.83a2.62 2.62 0 0 0-2 .85 5.31 5.31 0 0 0-1.22 2.11 7.93 7.93 0 0 0-.41 2.46 3.7 3.7 0 0 0 .43 2 1.31 1.31 0 0 0 1.17.71 2.42 2.42 0 0 0 1.37-.44 3.79 3.79 0 0 0 1-1l.93-6.28a2.08 2.08 0 0 0-1.27-.41ZM295.85 80.3q1.44-3.12 1.89-4.29h3.76l-.07.75-1.56.19-.34 11.2 1.49.21-.02.64h-4.82l.07-.68 1.6-.21.4-7.76.23-3.56L297.1 80l-4.1 9.08-.94.12-1.44-9-.55-3.33-.71 3.4-1.88 7.9 1.77.21-.07.68h-4.53l.07-.68 1.46-.21L289 77l-1.62-.19.11-.75h4.07l1.35 8.56.23 1.79.77-1.76q.49-1.22 1.94-4.35ZM308 88.64a4.35 4.35 0 0 1-2.23.59 3.38 3.38 0 0 1-2-.53 3.26 3.26 0 0 1-1.15-1.4 4.87 4.87 0 0 1-.36-1.87 7.34 7.34 0 0 1 .67-3.14 6 6 0 0 1 1.91-2.29 4.32 4.32 0 0 1 2.62-.87 2.63 2.63 0 0 1 1.88.59 2.06 2.06 0 0 1 .63 1.56 2.65 2.65 0 0 1-1 2.11 6.62 6.62 0 0 1-2.37 1.28 10 10 0 0 1-2.46.46 3.89 3.89 0 0 0 .42 2.13 1.69 1.69 0 0 0 1.6.9 3.61 3.61 0 0 0 1.54-.36 4.3 4.3 0 0 0 1.39-1l.38.65a4.52 4.52 0 0 1-1.47 1.19Zm-2.41-8a4.68 4.68 0 0 0-1 1.64 7.5 7.5 0 0 0-.44 1.94 6.11 6.11 0 0 0 1.86-.38 4.61 4.61 0 0 0 1.6-1 2 2 0 0 0 .65-1.47 1.54 1.54 0 0 0-.32-1 1.15 1.15 0 0 0-.89-.36 2 2 0 0 0-1.45.64ZM318.78 87.71c0 .29.09.44.26.44a1.42 1.42 0 0 0 .81-.44l.24.44a3.31 3.31 0 0 1-.76.71 1.9 1.9 0 0 1-1.15.36c-.69 0-1-.38-1-1.13v-.38a4.57 4.57 0 0 1-1.23 1.07 3.18 3.18 0 0 1-1.65.44 2.46 2.46 0 0 1-2.14-1 4.54 4.54 0 0 1-.72-2.68 7.24 7.24 0 0 1 .67-3 6.3 6.3 0 0 1 1.89-2.48 4.67 4.67 0 0 1 3-1 4.42 4.42 0 0 1 1.31.21l.48-3.16-1.16-.3.14-.61 2.47-.32.39.23-1.83 12.4a.59.59 0 0 0-.02.2Zm-2-7.7a2.62 2.62 0 0 0-2 .85 5.14 5.14 0 0 0-1.21 2.1 8 8 0 0 0-.4 2.47 3.83 3.83 0 0 0 .42 2 1.27 1.27 0 0 0 1.16.7 2.39 2.39 0 0 0 1.4-.46 3.7 3.7 0 0 0 1-1l.95-6.19a2.2 2.2 0 0 0-1.32-.48ZM324.44 87.71a.56.56 0 0 0 .08.32.25.25 0 0 0 .21.12.79.79 0 0 0 .39-.13 3.18 3.18 0 0 0 .5-.4l.23.42a3.35 3.35 0 0 1-.78.77 2 2 0 0 1-1.24.41 1.34 1.34 0 0 1-.89-.28.92.92 0 0 1-.25-.81c0-.29.18-1.43.46-3.41.16-1.06.36-2.47.59-4.22l-1.08-.41.1-.59 2.49-.41.39.2-1.18 8.24Zm-.07-10.81a1 1 0 0 1-.28-.68 1.29 1.29 0 0 1 .35-.9 1.1 1.1 0 0 1 .81-.37.92.92 0 0 1 1 .93 1.29 1.29 0 0 1-.34.92 1.11 1.11 0 0 1-.87.38.84.84 0 0 1-.67-.28ZM332.76 80.18a2.22 2.22 0 0 0-1.53.62 4.15 4.15 0 0 0-1.06 1.74 8 8 0 0 0-.37 2.55 4.09 4.09 0 0 0 .49 2.24 1.59 1.59 0 0 0 1.42.75 2.71 2.71 0 0 0 1.29-.28 5.56 5.56 0 0 0 1.15-.81l.35.65a4.84 4.84 0 0 1-1.3 1.08 3.94 3.94 0 0 1-2 .5 2.78 2.78 0 0 1-2.31-1 4.49 4.49 0 0 1-.83-2.9 7.35 7.35 0 0 1 .6-2.87 6.1 6.1 0 0 1 1.72-2.45 4.26 4.26 0 0 1 2.77-.94 5.66 5.66 0 0 1 1.06.1 3.31 3.31 0 0 1 .92.3l-.47 1.7-.3-.1a2.88 2.88 0 0 0-1.6-.88ZM338.88 87.71a.56.56 0 0 0 .12.29.23.23 0 0 0 .2.12.82.82 0 0 0 .4-.13 3.18 3.18 0 0 0 .5-.4l.23.42a3.56 3.56 0 0 1-.78.77 2 2 0 0 1-1.24.41 1.32 1.32 0 0 1-.89-.28.9.9 0 0 1-.25-.81c0-.29.18-1.43.46-3.41.16-1.06.36-2.47.59-4.22l-1.09-.41.11-.59 2.49-.41.39.2-1.18 8.24Zm-.08-10.81a1 1 0 0 1-.27-.68 1.29 1.29 0 0 1 .35-.9 1.07 1.07 0 0 1 .81-.37.92.92 0 0 1 1 .93 1.34 1.34 0 0 1-.34.92 1.11 1.11 0 0 1-.88.38.87.87 0 0 1-.67-.28ZM347.19 79.72a3.54 3.54 0 0 1 2-.64 1.89 1.89 0 0 1 1.51.59 2.93 2.93 0 0 1 .53 2 16.77 16.77 0 0 1-.39 2.68l-.07.41-.14.84a12.6 12.6 0 0 0-.28 2.12c0 .32.08.48.23.48a1.38 1.38 0 0 0 .82-.44l.21.45a1.91 1.91 0 0 1-.36.41 3.11 3.11 0 0 1-.7.44 1.93 1.93 0 0 1-.9.21 1 1 0 0 1-1.11-1.07 14.24 14.24 0 0 1 .32-2.14l.16-.85.07-.42c.11-.63.21-1.18.28-1.66a9 9 0 0 0 .1-1.32 1.87 1.87 0 0 0-.23-1.11 1 1 0 0 0-.84-.31 2.66 2.66 0 0 0-1.57.69 6.48 6.48 0 0 0-1.48 1.68l-.89 6.24h-1.66l1.12-8.49-.86-.42.14-.67 2.14-.38.37.19-.23 2.1a6.52 6.52 0 0 1 1.71-1.61ZM359 88.64a4.35 4.35 0 0 1-2.23.59 3.34 3.34 0 0 1-1.95-.53 3.19 3.19 0 0 1-1.15-1.4 4.69 4.69 0 0 1-.37-1.87 7.34 7.34 0 0 1 .67-3.14 6 6 0 0 1 1.9-2.29 4.35 4.35 0 0 1 2.63-.87 2.61 2.61 0 0 1 1.87.59 2 2 0 0 1 .64 1.56 2.68 2.68 0 0 1-1 2.11 6.75 6.75 0 0 1-2.38 1.28 9.81 9.81 0 0 1-2.46.46 4.08 4.08 0 0 0 .42 2.13 1.69 1.69 0 0 0 1.6.9 3.65 3.65 0 0 0 1.55-.36 4.37 4.37 0 0 0 1.38-1l.39.65a4.57 4.57 0 0 1-1.51 1.19Zm-2.4-8a4.54 4.54 0 0 0-1 1.64 6.76 6.76 0 0 0-.44 1.94 6 6 0 0 0 1.85-.38 4.52 4.52 0 0 0 1.6-1 2 2 0 0 0 .65-1.47 1.49 1.49 0 0 0-.32-1 1.14 1.14 0 0 0-.89-.36 2 2 0 0 0-1.41.64Z" class="cls-1" transform="translate(-24.97 -24.05)"></path>
            </svg>
          </FooterLogo>
          <div>
            <OrgLink
              href="http://www.nasonline.org/"
              rel="noreferrer"
              target="_blank"
            >
              <OrgLogo src={NASOnline} alt="NAS Logo" />
              <span>National Academy of Sciences</span>
            </OrgLink>

            <OrgLink
              href="https://www.nae.edu/"
              rel="noreferrer"
              target="_blank"
            >
              <OrgLogo src={NAEOnline} alt="NAE Logo" />
              <span>National Academy of Engineering</span>
            </OrgLink>

            <OrgLink href="https://nam.edu/" rel="noreferrer" target="_blank">
              <OrgLogo src={NAMOnline} alt="NAM Logo" />
              <span>National Academy of Medicine</span>
            </OrgLink>
          </div>
        </OrgLinks>
        <FooterLinks>
          <FooterList>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/about"
                target="_self"
              >
                About Us
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/our-work"
                target="_self"
              >
                Our Work
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/events"
                target="_self"
              >
                Events
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/contact-us"
                target="_self"
              >
                Contact Us
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/opportunities"
                target="_self"
              >
                Opportunities
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/publications"
                target="_self"
              >
                Publications
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/about/visiting-us"
                target="_self"
              >
                Visit
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/about/operating-status"
                target="_self"
              >
                Current Operating Status
              </FooterLink>
            </FooterItem>
            <FooterItem>
              <FooterLink
                rel=""
                title=""
                href="https://www.nationalacademies.org/subscribe"
                target="_self"
              >
                E-Newsletters
              </FooterLink>
            </FooterItem>
          </FooterList>
          <FooterSocials>
            <FooterSocialConnect>Connect With Us</FooterSocialConnect>
            <FooterSocialList>
              <FooterSocialItem>
                <FooterSocialLink
                  href="https://www.facebook.com/NationalAcademies/"
                  target="_self"
                >
                  <FooterSocialImage src={ConnectFacebook} />
                </FooterSocialLink>
              </FooterSocialItem>
              <FooterSocialItem>
                <FooterSocialLink
                  href="https://twitter.com/TheNASEM"
                  target="_self"
                >
                  <FooterSocialImage src={ConnectTwitter} />
                </FooterSocialLink>
              </FooterSocialItem>
              <FooterSocialItem>
                <FooterSocialLink
                  href="https://www.linkedin.com/company/the-national-academies"
                  target="_self"
                >
                  <FooterSocialImage src={ConnectLinkedIn} />
                </FooterSocialLink>
              </FooterSocialItem>
              <FooterSocialItem>
                <FooterSocialLink
                  href="http://www.nationalacademies.org/news.xml"
                  title="Share our site"
                  target="_self"
                >
                  <FooterSocialImage src={ConnectRSS} />
                </FooterSocialLink>
              </FooterSocialItem>
              <FooterSocialItem>
                <FooterSocialLink
                  href="https://www.nationalacademies.org/subscribe"
                  title="Subscribe"
                  target="_self"
                >
                  <FooterSocialImage src={ConnectEmail} />
                </FooterSocialLink>
              </FooterSocialItem>
            </FooterSocialList>
          </FooterSocials>
          <FooterLegal>
            <div>
              <a href="https://www.nationalacademies.org/giving" target="_self">
                <FooterLegalButton>
                  Donate Today
                  <FooterLegalSpan>
                    <FooterLegalIcon src={DonateIcon} />
                  </FooterLegalSpan>
                </FooterLegalButton>
              </a>
            </div>
            <div>
              <FooterLegalList>
                <FooterLegalItem>
                  <FooterLegalLink
                    href="https://www.nationalacademies.org/legal/privacy"
                    target="_self"
                  >
                    Privacy Statement
                  </FooterLegalLink>
                </FooterLegalItem>
                <FooterLegalItem>
                  <FooterLegalLink
                    href="https://www.nationalacademies.org/legal/policy"
                    target="_self"
                  >
                    DMCA Policy
                  </FooterLegalLink>
                </FooterLegalItem>
                <FooterLegalItem>
                  <FooterLegalLink
                    href="https://www.nationalacademies.org/legal/terms"
                    target="_self"
                  >
                    Terms of Use
                  </FooterLegalLink>
                </FooterLegalItem>
                <FooterLegalItem>
                  <FooterLegalLink
                    href="https://www.nationalacademies.org/site-map"
                    target="_self"
                  >
                    Site Map
                  </FooterLegalLink>
                </FooterLegalItem>
              </FooterLegalList>
              <FooterLegalCopyright>
                <FooterLegalCopyrightLink
                  href="https://www.nationalacademies.org/legal"
                  target="_self"
                >
                  Copyright © 2021 National Academy of Sciences. All Rights
                  Reserved.
                </FooterLegalCopyrightLink>
              </FooterLegalCopyright>
            </div>
          </FooterLegal>
        </FooterLinks>
      </FlexContainer>
    </FooterBackground>
  );
}

export default Footer;
